import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import getCookie from '../../helper/getCookie';
import setCookie from '../../helper/setCookie';
import getDecryptData from '../../helper/getDecryptData';
import eraseCookie from '../../helper/eraseCookie';
import LoginComponents from '../components/LoginComponents';
import { useBlogContext } from '../../fetchdata/BlogContext';

const CryptoJS = window.CryptoJS;

const Checkout = ({ updateAuthStatus }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    cartItems,
    Headers,
    isHeader,
    totalAmount,
    clearAllItemsInCart,
    removePromoCode,
    applyPromoCode,
    promoCodeInfo,
    mypromoCode,
    sendMessage
  } = useBlogContext();

  const otpInputs = useRef([]);

  // ---------------- LOCATION PICKUP ----------------
  const [pickupLocation, setPickupLocation] = useState('');
  const [PickupCoordinates, setPickupCoordinates] = useState({});
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [ConfirmLocation, setConfirmLocation] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");

  const clearPickup = () => {
    setConfirmLocation(false);
    setPickupLocation("");
  };

  const handleSaveCurrentLocation = () => {
    const location = localStorage.getItem("selectedLocation");
    if (location) {
      setSelectedLocation(location);
      setPickupLocation(location);
      setPickupSuggestions([]);
    }
    setConfirmLocation(false);
  };

  const handleSearchPickupClick = (result) => {
    setPickupSuggestions([]);
    setSelectedLocation(result.description);
    setPickupLocation(result.description);
  };

  const handlePickupChange = (e) => {
    const value = e.target.value;
    setPickupLocation(value);

    if (value.trim() !== "") {
      const autocompleteService = new window.google.maps.places.AutocompleteService();

      autocompleteService.getPlacePredictions({ input: value }, (predictions) => {
        if (predictions && predictions.length > 0) {
          const suggestedPlaces = predictions.map((prediction) => prediction);
          setPickupSuggestions(suggestedPlaces);

          const placeId = predictions[0].place_id;
          const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));

          const request = {
            placeId: placeId,
            fields: ['geometry', 'name'],
          };

          placesService.getDetails(request, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              setPickupCoordinates({ lat, lng });
            }
          });
        } else {
          setPickupSuggestions([]);
        }
      });
    } else {
      setPickupSuggestions([]);
    }

    setConfirmLocation(true);
  };

  const sanitizeInput = (input) => {
    return input.replace(/[^\w\s@.\-]/gi, '');
  };

  // ---------------- GENERAL STATE ----------------
  const [countdown, setCountdown] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orderProcess, setOrderProcess] = useState(false);
  const [SubmitLoading, setSubmitLoading] = useState(true);
  const [shippingCharge, setshippingCharge] = useState(0);
  const [mode, setMode] = useState('COD');
  const [showModal, setShowModal] = useState(false);
  const [PaymentMethod, setPaymentMethod] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [promoCode, setPromoCode] = useState('');
  const [combinedOTP, setcombinedOTP] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [GetEmailOTP, setEmailOTP] = useState(null);
  const [EmailVerify, setEmailVerify] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [LogincurrentStep, setLoginCurrentStep] = useState(1);

  const isLoginFromLocalStorage = getCookie('token') ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);
  const [isLoginForm, setIsLoginForm] = useState(true);

  // ---------------- COUNTRY / STATE / CITY ----------------
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  // ---------------- TAX SUMMARY ----------------
  const [taxSummary, setTaxSummary] = useState({
    taxAmount: 0,
    itemsTax: [],
    finalTotal: 0,
  });

  // ---------------- USER PROFILE FORM ----------------
  const userString = getCookie('user');

  let initialUserData = {
    username: '',
    phone: '',
    pincode: '',
    country: '',
    countryName: '',
    state: '',
    stateName: '',
    city: '',
    cityName: '',
    address: '',
    email: '',
  };

  if (userString) {
    const parsed = JSON.parse(userString);
    initialUserData = {
      username: parsed.username || '',
      phone: parsed.phone || '',
      pincode: parsed.pincode || '',
      country: parsed.country || '',
      countryName: parsed.countryName || '',
      state: parsed.state || '',
      stateName: parsed.stateName || '',
      city: parsed.city || '',
      cityName: parsed.cityName || '',
      address: parsed.address || '',
      email: parsed.email || '',
    };
  }

  const [Orderinputs, setOrderInputs] = useState(initialUserData);

  const [inputs, setInputs] = useState({
    username: '',
    email: '',
    password: '',
  });

  const [Logininputs, setLoginInputs] = useState({
    email: '',
    password: '',
  });

  // ---------------- HELPERS ----------------
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  function pkcs5_pad(text, blocksize) {
    var padding = blocksize - (text.length % blocksize);
    for (var i = 0; i < padding; i++) {
      text += String.fromCharCode(padding);
    }
    return text;
  }

  function encrypt(plainText, key) {
    var secretKey = CryptoJS.enc.Hex.parse(CryptoJS.MD5(key).toString(CryptoJS.enc.Hex));
    var initVector = CryptoJS.enc.Utf8.parse(Array(16).fill(0).map((_, i) => String.fromCharCode(i)).join(''));
    var plainPad = pkcs5_pad(plainText, 16);
    var encryptedText = CryptoJS.AES.encrypt(plainPad, secretKey, {
      iv: initVector,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.NoPadding
    });
    return encryptedText.ciphertext.toString(CryptoJS.enc.Hex);
  }

  function decrypt(encryptedText, key) {
    var secretKey = CryptoJS.enc.Hex.parse(CryptoJS.MD5(key).toString(CryptoJS.enc.Hex));
    var initVector = CryptoJS.enc.Utf8.parse(Array(16).fill(0).map((_, i) => String.fromCharCode(i)).join(''));
    var encryptedData = CryptoJS.enc.Hex.parse(encryptedText);
    var decryptedText = CryptoJS.AES.decrypt({ ciphertext: encryptedData }, secretKey, {
      iv: initVector,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.NoPadding
    });
    return decryptedText.toString(CryptoJS.enc.Utf8).replace(/[\x00-\x1F\x80-\xFF]+$/g, '');
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleModeChange = (e) => {
    setMode(e.target.value);
  };

  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handlePaymentMethodChange = (event) => {
    const { id, checked } = event.target;
    setPaymentMethod(prevState => {
      if (checked) {
        return prevState + id + ',';
      } else {
        return prevState.replace(id + ',', '');
      }
    });
  };

  const isCheckPaymentMethodChecked = (id) => {
    return PaymentMethod.includes(id);
  };

  const handleRemovePromoCode = () => {
    toast.success('Promo code removed');
    removePromoCode();
  };

  const handleApplyPromoCode = () => {
    applyPromoCode(promoCode);
  };

  const handleNext = () => {
    if (EmailVerify) {
      setCurrentStep(currentStep + 1);
    } else {
      toast.error('Need to verify email first');
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleLoginNext = () => {
    setLoginCurrentStep(LogincurrentStep + 1);
  };

  const handleLoginPrevious = () => {
    setLoginCurrentStep(LogincurrentStep - 1);
  };

  useEffect(() => {
    setIsChecked(false);
  }, [currentStep, LogincurrentStep]);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage, dispatch]);

  // ---------------- SHIPPING CHARGE LOGIC (UNCHANGED) ----------------
  const getTotalFinalAmount = (weight, shippingRatesStr) => {
    if (shippingRatesStr?.length !== 0) {
      const shippingRates = shippingRatesStr.split(',').map(rateStr => {
        const [rangeStr, chargeStr] = rateStr.split(':');
        const [minWeightStr, maxWeightStr] = rangeStr.split('-');
        return {
          minWeight: parseFloat(minWeightStr),
          maxWeight: parseFloat(maxWeightStr),
          charge: parseFloat(chargeStr)
        };
      });

      const rate = shippingRates.find(rate => weight >= rate.minWeight && weight <= rate.maxWeight);

      if (rate) {
        setshippingCharge(rate.charge);
      } else {
        setshippingCharge(0);
        return 0;
      }
    } else {
      setshippingCharge(0);
      return 0;
    }
  };

  // ---------------- LOCATION APIS ----------------
  const fetchCountries = async () => {
    try {
      const response = await axiosInstance.get("/countries");
      setCountries(response.data.countries || []);
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Error fetching countries");
    }
  };

  const fetchStatesByCountry = async (countryId) => {
    try {
      if (!countryId) {
        setStates([]);
        return;
      }
      const response = await axiosInstance.get(`/states/${countryId}`);
      setStates(response.data.states || []);
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Error fetching states");
    }
  };

  const fetchCitiesByState = async (stateId) => {
    try {
      if (!stateId) {
        setCities([]);
        return;
      }
      const response = await axiosInstance.get(`/cities/${stateId}`);
      setCities(response.data.cities || []);
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Error fetching cities");
    }
  };

  // ---------------- TAX CALCULATION ----------------
  const calculateCartTax = async () => {
    try {
      if (!Orderinputs.country || cartItems.length === 0) {
        setTaxSummary({
          taxAmount: 0,
          itemsTax: [],
          finalTotal: cartItems.reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0) + Number(shippingCharge || 0),
        });
        return;
      }

      let totalTaxAmount = 0;
      const itemsTax = [];

      for (const item of cartItems) {
        const subtotal = Number(item.price) * Number(item.quantity);

        const response = await axiosInstance.post("/estimate-tax", {
          countryId: Orderinputs.country,
          stateId: Orderinputs.state || null,
          cityId: Orderinputs.city || null,
          areaId: null,
          categoryId: item.categoryId || null,
          subtotal,
        });

        const taxData = response.data?.tax || {};
        const itemTax = Number(taxData.taxAmount || 0);

        totalTaxAmount += itemTax;

        itemsTax.push({
          productId: item.id,
          title: item.title,
          categoryId: item.categoryId || null,
          subtotal,
          taxAmount: itemTax,
          total: Number(taxData.total || subtotal),
          appliedRule: response.data?.appliedRule || null,
        });
      }

      const cartSubtotal = cartItems.reduce(
        (total, item) => total + Number(item.price) * Number(item.quantity),
        0
      );

      const shipping = Number(shippingCharge || 0);
      const finalTotal = cartSubtotal + totalTaxAmount + shipping;

      setTaxSummary({
        taxAmount: totalTaxAmount,
        itemsTax,
        finalTotal,
      });
    } catch (error) {
      console.error("Error calculating tax:", error);
      toast.error("Error calculating tax");
    }
  };

  useEffect(() => {
    if (Orderinputs.country && cartItems.length > 0) {
      calculateCartTax();
    }
  }, [Orderinputs.country, Orderinputs.state, Orderinputs.city, cartItems, shippingCharge]);

  // ---------------- AUTH USER FETCH ----------------
  useEffect(() => {
    const checkUserToken = async () => {
      const usertoken = getCookie('token');
      if (usertoken) {
        // welcome logic if needed
      }
    };
    checkUserToken();
  }, [dispatch, navigate]);

  useEffect(() => {
    const init = async () => {
      await fetchCountries();
    };
    init();
  }, []);

  useEffect(() => {
    if (isLogin === true) {
      const fetchUserById = async () => {
        try {
          const decryptdatajson = await getDecryptData();
          const credentials = { id: decryptdatajson?._id };

          const { data } = await axiosInstance.post('/auth-user', credentials);
          const { success, existingUser } = data;

          if (success) {
            setOrderInputs((prevData) => ({
              ...prevData,
              username: existingUser.username || '',
              phone: existingUser.phone || '',
              email: existingUser.email || '',
              address: existingUser.address || '',
              pincode: existingUser.pincode || '',
              country: existingUser.country || '',
              countryName: existingUser.countryName || '',
              state: existingUser.state || '',
              stateName: existingUser.stateName || '',
              city: existingUser.city || '',
              cityName: existingUser.cityName || '',
            }));

            if (existingUser?.verified === 1) {
              setEmailVerify(true);
            }

            if (existingUser.country) {
              await fetchStatesByCountry(existingUser.country);
            }
            if (existingUser.state) {
              await fetchCitiesByState(existingUser.state);
            }
          }
        } catch (error) {
          console.error('Error during auth-user:', error);
          toast.error(error?.response?.data?.message || "Error fetching user");
        }
      };

      fetchUserById();
    }
  }, [isLogin]);

  // ---------------- HANDLE ORDER INPUT CHANGE ----------------
  const handleOrderChange = async (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;

    if (name !== 'email') {
      sanitizedValue = sanitizeInput(value);
    }

    if (name === "country") {
      const selectedCountry = countries.find((item) => item._id === value);

      setOrderInputs((prev) => ({
        ...prev,
        country: value,
        countryName: selectedCountry?.name || "",
        state: "",
        stateName: "",
        city: "",
        cityName: "",
      }));

      setStates([]);
      setCities([]);
      await fetchStatesByCountry(value);
      return;
    }

    if (name === "state") {
      const selectedState = states.find((item) => item._id === value);

      setOrderInputs((prev) => ({
        ...prev,
        state: value,
        stateName: selectedState?.name || "",
        city: "",
        cityName: "",
      }));

      setCities([]);
      await fetchCitiesByState(value);
      return;
    }

    if (name === "city") {
      const selectedCity = cities.find((item) => item._id === value);

      setOrderInputs((prev) => ({
        ...prev,
        city: value,
        cityName: selectedCity?.name || "",
      }));
      return;
    }

    setOrderInputs((prevState) => ({
      ...prevState,
      [name]: sanitizedValue,
    }));
  };

  const getCheckoutItems = () =>
    cartItems.map((item) => ({
      ...item,
      productId: item.productId || item.pid || item._id || item.id,
    }));

  // ---------------- ORDER PAYLOAD ----------------
  const Ordercredentials = {
    phone: Orderinputs.phone,
    pincode: Orderinputs.pincode,
    country: Orderinputs.country,
    state: Orderinputs.state,
    city: Orderinputs.city,
    address: Orderinputs.address,
    items: getCheckoutItems(),
    status: '1',
    mode: 'COD',
    details: {
      username: Orderinputs.username,
      phone: Orderinputs.phone,
      pincode: Orderinputs.pincode,
      country: Orderinputs.countryName,
      state: Orderinputs.stateName,
      city: Orderinputs.cityName,
      address: Orderinputs.address,
      email: Orderinputs.email,
    },
    discount: '',
    shipping: '',
    totalAmount: '',
    payment: 0,
  };

  // ---------------- ORDER SUBMIT ----------------
  const handleOrderSubmit = async (e) => {
    const decryptdatajson = await getDecryptData();
    const userId = decryptdatajson?._id;

    if (!mode && mode !== '') {
      toast.error('Please Choose Payment Method');
      return;
    }

    if (
      !Orderinputs.username ||
      !Orderinputs.phone ||
      !Orderinputs.email ||
      !Orderinputs.pincode ||
      !Orderinputs.address ||
      !Orderinputs.country ||
      !Orderinputs.state ||
      !Orderinputs.city
    ) {
      toast.error('Please Fill All Details');
      handlePrevious();
      return;
    }

    if (!mode) {
      toast.error('Please Choose Payment Mode');
      return;
    }

    e.preventDefault();

    const shipping = Number(shippingCharge || 0);
    const taxAmount = Number(taxSummary.taxAmount || 0);

    const cartSubtotal = cartItems.reduce(
      (total, item) => total + Number(item.quantity) * Number(item.price),
      0
    );

    let discount = 0;
    if (promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0) {
      discount = Math.max(
        0,
        cartSubtotal - Number(totalAmount || 0)
      );
    }

    const Total = cartSubtotal + shipping + taxAmount - discount;

    const updatedFormData = {
      ...Ordercredentials,
      phone: Orderinputs.phone,
      pincode: Orderinputs.pincode,
      address: Orderinputs.address,
      username: Orderinputs.username,
      email: Orderinputs.email,
      mode: mode,
      userId: userId,
      totalAmount: Total,
      discount: discount,
      shipping: shipping,
      taxAmount: taxAmount,
      country: Orderinputs.country,
      state: Orderinputs.state,
      city: Orderinputs.city,
      countryName: Orderinputs.countryName,
      stateName: Orderinputs.stateName,
      cityName: Orderinputs.cityName,
      verified: 1,
    };

    try {
      setOrderProcess(true);

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(Orderinputs.email)) {
        toast.error('Invalid email format');
        return;
      }

      const response = await axiosInstance.post(`/create-odoo-order/${userId}`, updatedFormData);

      // if (success && newOrder?.userId?.[0]) {
      //   const sendmsg = {
      //     userId: newOrder.userId[0],
      //     type: "book",
      //     order: newOrder,
      //     orderId: newOrder?.orderId
      //   };
      //   await sendMessage(sendmsg);
      // }

      if (response && response.data && mode !== "COD") {
        sessionStorage.setItem('lastOdooOrder', JSON.stringify({
          orderId: response.data?.odooOrder?.name || response.data?.order_id,
          totalAmount: Total,
          odooOrder: response.data?.odooOrder,
        }));
        removePromoCode();
        clearAllItemsInCart();

        var plainText = `tid=${response.data.tid}&merchant_id=${response.data.merchant_id}&order_id=${response.data.order_id}&amount=${Total}&currency=INR&redirect_url=${response.data.redirect_url}&cancel_url=${response.data.cancel_url}`;
        var key = response.data.WORKING_KEY;
        var encryptedData = encrypt(plainText, key);

        const form = document.createElement('form');
        form.method = 'post';
        form.action = `https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction&encRequest=${encryptedData}&access_code=${response.data.accessCode}`;

        const createAndAppendInput = (name, value) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        };

        createAndAppendInput('encRequest', encryptedData);

        document.body.appendChild(form);
        form.submit();
      } else if (response.data.success === true && mode === "COD") {
        sessionStorage.setItem('lastOdooOrder', JSON.stringify({
          orderId: response.data?.odooOrder?.name || response.data?.orderId,
          totalAmount: Total,
          odooOrder: response.data?.odooOrder,
        }));
        clearAllItemsInCart();
        removePromoCode();
        navigate('/complete-order');
      }
    } catch (error) {
      console.error('Error during order:', error);
      toast.error(error?.response?.data?.message || "Order failed");
    } finally {
      setOrderProcess(false);
    }
  };

  // ---------------- SIGNUP ----------------
  const credentials = {
    username: inputs.username,
    email: inputs.email,
    password: inputs.password
  };

  const handleSignupChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axiosInstance.post('/signup', credentials);
      const { success, user } = data;

      if (success) {
        setCookie('token', user.token, 7);
        setCookie('userId', user._id, 7);
        toast.success("login sucesssfully");
        dispatch(authActions.login());
        setIsLogin(true);
      }
    } catch (error) {
      console.error('Error during signup:', error);
      toast.error(error?.response?.data?.message || "Signup failed");
    }
  };

  // ---------------- EMAIL VERIFY ----------------
  const verifyemail = async () => {
    toast.success("OTP Send to your email address");
    try {
      const { data } = await axiosInstance.post('/email-verify', Orderinputs);
      if (data) {
        setEmailOTP(data.OTP);
      }
    } catch (error) {
      setEmailOTP(1234);
      toast.success('1234');
      console.error('Error during verifyemail:', error);
    }
  };

  const CheckEmail = async () => {
    if (GetEmailOTP === null) {
      toast.error("OTP Not Verifed");
    } else if (Orderinputs.EmailOTP?.toString() === GetEmailOTP?.toString()) {
      toast.success("OTP Verifed");
      setEmailVerify(true);
    } else {
      toast.error("OTP Not Verifed");
    }
  };

  const handleInputChange = async (index, event) => {
    const input = event.target;
    const maxLength = parseInt(input.getAttribute('maxlength'));
    const currentLength = input.value.length;

    if (event.nativeEvent.inputType === 'deleteContentBackward' && currentLength === 0 && index > 0) {
      otpInputs.current[index - 1]?.focus();
    } else if (currentLength === maxLength && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1]?.focus();
    }

    const allFilled = otpInputs.current.every(input => input && input.value.trim() !== '');
    if (allFilled && index === otpInputs.current.length - 1) {
      const combinedValue = otpInputs.current.map(input => input.value.trim()).join('');
      setcombinedOTP(combinedValue);
    }
  };

  // ---------------- JSX ----------------
  return (
    <>
      <Header />

      <Helmet>
        <title> Checkout | {window.location.hostname}</title>
      </Helmet>

      <div className="bg-light">
        <div className="py-4">
          <div className="container d-lg-flex justify-content-between align-items-center py-2 py-lg-4">
            <div className="pe-lg-4 text-center text-lg-start">
              <h1 className="h3 mb-0">Checkout billing</h1>
            </div>
            <div className="pt-2 pt-lg-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-start">
                  <li className="breadcrumb-item">
                    <Link className="text-nowrap" to="/">
                      <i className="ri-store-2-line" /> Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item text-nowrap active" aria-current="page">
                    Checkout billing
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        <div className="container pb-4 pb-lg-10 mt-3">
          <div className="row g-4 g-lg-10" style={{ position: "relative" }}>
            {orderProcess && (
              <div
                className="orderpanel"
                style={{
                  width: "100%",
                  borderRadius: 5,
                  margin: 0,
                  height: "100%",
                  position: "fixed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                  background: "#ffffffa1",
                  left: 0,
                  top: 0,
                  color: "white",
                }}
              >
                <div className="page text-center">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <div className="loader-outer">
                        <div className="loader" />
                      </div>
                      <h2 className='text-dark'>PROCESSING YOUR ORDER</h2>
                    </div>
                    <div className="panel-body">
                      <p className='text-dark'>
                        Hold tight, your order is being processed, please do not navigate away
                        from the current window or refresh the page.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="page d-none">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <div className="loader-outer">
                    <div className="loader" />
                  </div>
                  <h2>PROCESSING YOUR ORDER</h2>
                </div>
                <div className="panel-body">
                  <p>
                    Hold tight, your order is being processed, please do not navigate away
                    from the current window or refresh the page.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="steps steps-dark border rounded-2 p-4 p-sm-5 mb-4 bg-white">
                <a className="step-item active" href="#">
                  <div className="step-progress">
                    <div className="step-icon">
                      <i className="ri-shopping-cart-2-line" />
                    </div>
                  </div>
                  <div className="step-label"> Cart </div>
                </a>

                <a className="step-item active current" href="#">
                  <div className="step-progress">
                    <div className="step-icon">
                      <i className="ri-user-4-line" />
                    </div>
                  </div>
                  <div className="step-label"> Checkout </div>
                </a>

                <a className="step-item" href="#">
                  <div className="step-progress">
                    <div className="step-icon">
                      <i className="ri-bank-card-line" />
                    </div>
                  </div>
                  <div className="step-label"> Payment </div>
                </a>
              </div>

              {currentStep === 1 && (
                <>
                  <div className="border rounded-3 p-4 bg-white">
                    <div className="alert alert-success alert-dismissible fade show d-none" role="alert">
                      <a className="fw-medium" href="#" data-toggle="modal" data-target="#LoginModel">
                        Login
                      </a>{" "}
                      or{" "}
                      <a className="fw-medium" href="#" data-toggle="modal" data-target="#RegisterModel">
                        Register
                      </a>{" "}
                      for faster payment.
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                      />
                    </div>

                    {!isLogin && (
                      <div
                        className="m-auto rounded-3 shadow p-4 bg-white"
                        style={{ maxWidth: 450, minHeight: 400 }}
                      >
                        <LoginComponents updateAuth={updateAuthStatus} />
                      </div>
                    )}

                    {isLogin ? (
                      <>
                        <h4 className='CapiTaliZed'>Welcome Back {Orderinputs?.username}</h4>

                        {Orderinputs.phone ? (
                          <>
                            <div className="row">
                              <div className="col-md-12">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="username">
                                    Full Name
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    id="username"
                                    name="username"
                                    value={Orderinputs.username}
                                    onChange={handleOrderChange}
                                  />
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="phone">
                                    Phone No.
                                  </label>
                                  <input
                                    className="form-control bg-light"
                                    type="number"
                                    id="phone"
                                    readOnly
                                    name="phone"
                                    value={Orderinputs.phone}
                                  />
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="Email">
                                    Email
                                  </label>
                                  <div className="input-group">
                                    <input
                                      className="form-control"
                                      type="email"
                                      id="Email"
                                      name="email"
                                      value={Orderinputs.email}
                                      onChange={handleOrderChange}
                                    />
                                    {!EmailVerify && (
                                      <button className="btn btn-danger" onClick={verifyemail} type="button">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={20}
                                          height={20}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#ffffff"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <circle cx={12} cy={12} r={10} />
                                          <line x1={12} y1={8} x2={12} y2={12} />
                                          <line x1={12} y1={16} x2="12.01" y2={16} />
                                        </svg>{' '}
                                        Verify
                                      </button>
                                    )}
                                  </div>
                                </div>

                                {!EmailVerify && GetEmailOTP && (
                                  <div className='bg-light p-2 mb-2 rounded'>
                                    <label> OTP Send to your email address </label>

                                    <div className="input-group my-3">
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        placeholder="Enter OTP"
                                        name='EmailOTP'
                                        value={Orderinputs.EmailOTP || ""}
                                        onChange={handleOrderChange}
                                        onKeyPress={(e) => { if (e.target.value.length === 4) e.preventDefault(); }}
                                      />
                                      <button
                                        className="btn btn-success btn-sm"
                                        type="button"
                                        onClick={CheckEmail}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="col-md-4">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="country">
                                    Country
                                  </label>
                                  <select
                                    className="form-select"
                                    id="country"
                                    name="country"
                                    value={Orderinputs.country}
                                    onChange={handleOrderChange}
                                  >
                                    <option value="">Select Country</option>
                                    {countries.map((item) => (
                                      <option key={item._id} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="state">
                                    State
                                  </label>
                                  <select
                                    className="form-select"
                                    id="state"
                                    name="state"
                                    value={Orderinputs.state}
                                    onChange={handleOrderChange}
                                    disabled={!Orderinputs.country}
                                  >
                                    <option value="">Select State</option>
                                    {states.map((item) => (
                                      <option key={item._id} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="city">
                                    City
                                  </label>
                                  <select
                                    className="form-select"
                                    id="city"
                                    name="city"
                                    value={Orderinputs.city}
                                    onChange={handleOrderChange}
                                    disabled={!Orderinputs.state}
                                  >
                                    <option value="">Select City</option>
                                    {cities.map((item) => (
                                      <option key={item._id} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="mb-4">
                                  <label className="form-label" htmlFor="pincode">
                                    Pincode
                                  </label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    id="pincode"
                                    name="pincode"
                                    value={Orderinputs.pincode}
                                    onChange={handleOrderChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <label className="form-label" htmlFor="address">
                                Full Address
                              </label>
                              <textarea
                                className="form-control"
                                id="address"
                                rows="3"
                                name="address"
                                value={Orderinputs.address}
                                onChange={handleOrderChange}
                              ></textarea>
                            </div>
                          </>
                        ) : (
                          <div id="wrapper">
                            <div className="profile-main-loader d-flex align-items-center justify-content-center" style={{ height: '50vh' }}>
                              <div className="spinner-border" role="status" style={{ width: 150, height: 150 }} />
                            </div>
                          </div>
                        )}
                      </>
                    ) : null}
                  </div>
                </>
              )}

              {currentStep === 2 && (
                !isHeader ? (
                  <>
                    <div className="accordion mb-4" id="payment-method">
                      <div className="accordion-item">
                        <h3 className="accordion-header">
                          <div className="form-check accordion-button collapsed">
                            <input
                              className="form-check-input fs-lg me-2 ms-0 align-right"
                              value="COD"
                              onChange={handleModeChange}
                              name="mode"
                              type="radio"
                              id="COD"
                              checked={mode === "COD"}
                            />
                            <label className="form-check-label widget-filter-item-label w-100" htmlFor="COD">
                              Pay Later
                            </label>
                          </div>
                        </h3>
                      </div>
                    </div>

                    {Headers?.razorpay === 'true' && (
                      <div className="accordion mb-4" id="payment-method">
                        <div className="accordion-item">
                          <h3 className="accordion-header">
                            <div className="form-check accordion-button collapsed">
                              <input
                                className="form-check-input fs-lg me-2 ms-0 align-right"
                                value="CCAvenue"
                                onChange={handleModeChange}
                                name="mode"
                                type="radio"
                                id="CCAvenue"
                                checked={mode === "CCAvenue"}
                              />
                              <label className="form-check-label widget-filter-item-label w-100" htmlFor="CCAvenue">
                                Pay Now
                              </label>
                            </div>
                          </h3>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <> Payment Method Loading... </>
                )
              )}

              <div className="d-flex align-items-center justify-content-between mt-8">
                {(currentStep === 1 && isLogin) && (
                  <>
                    {cartItems && cartItems.length > 0 ? (
                      <button className="btn btn-primary mt-3" onClick={handleNext}>
                        Proceed to Payment
                      </button>
                    ) : (
                      <Link className="btn btn-primary mt-3" to="/">Shop Now</Link>
                    )}
                  </>
                )}

                {currentStep === 2 && (
                  <>
                    <button className="btn btn-secondary" onClick={handlePrevious}>
                      Back
                    </button>

                    <button type="button" className="btn btn-primary" onClick={handleOrderSubmit}>
                      Place Order
                    </button>
                  </>
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card border">
                <div className="card-body">
                  {cartItems.map((item) => (
                    <div key={`${item.id}-${item.color || ""}`} className="mb-4">
                      <div className="d-flex align-items-center pb-2 border-bottom">
                        <Link className="d-block flex-shrink-0" to={`/product/${item.id}`}>
                          <img src={item.image} width={60} alt="Product" />
                        </Link>
                        <div className="ps-2">
                          <h6 className="fs-md mb-1">
                            <Link to={`/product/${item.id}`} className="link-hover-primary">
                              {item.title} - {item.color}
                            </Link>
                          </h6>
                          <div className="fs-sm">
                            <span className="text-accent me-2">${item.price}</span>
                            <span className="text-body-secondary">Quantity: </span>
                            <span className="text-body-secondary">{item.quantity}</span>
                          </div>

                          <div className="fs-sm">
                            <span className="text-body-secondary">Total Price: </span>
                            <span className="text-body-secondary">${item.quantity * item.price}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {cartItems && cartItems.length > 0 ? (
                    <>
                      {promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0 ? (
                        <>
                          <div className="d-flex align-items-center justify-content-between">
                            <p>Sub Total </p>
                            <p>${cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}</p>
                          </div>

                          <div className="d-flex align-items-center justify-content-between">
                            <p>Discount </p>
                            <p>
                              - $
                              {Math.abs(
                                Math.max(
                                  0,
                                  cartItems.reduce((total, item) => total + item.quantity * item.price, 0) - Number(totalAmount || 0)
                                )
                              )}
                            </p>
                          </div>

                          <div className="d-flex align-items-center justify-content-between">
                            <p>Tax</p>
                            <p>+ $ {Number(taxSummary.taxAmount || 0).toFixed(2)}</p>
                          </div>

                          <div className="d-flex align-items-center justify-content-between">
                            <p>Shipping</p>
                            <p>+ $ {shippingCharge ? shippingCharge : 0}</p>
                          </div>

                          <div className="d-flex align-items-center justify-content-between">
                            <h5>Total</h5>
                            <h5>$ {Number(taxSummary.finalTotal || 0).toFixed(2)}</h5>
                          </div>

                          <div className="d-flex align-items-center justify-content-between mypromobox mb-2">
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <i className="ri-checkbox-circle-line text-success h4"></i>

                              <p className='m-0'>
                                <b>{mypromoCode}</b> applied <br />
                                {promoCodeInfo.type === "percentage" ? (
                                  <>{promoCodeInfo.discount * 100}% OFF</>
                                ) : (
                                  <>{promoCodeInfo.discount} OFF</>
                                )}
                              </p>
                            </div>

                            <button type="button" className="btn btn-danger p-2" onClick={handleRemovePromoCode}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={16}
                                height={16}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#ffffff"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                <line x1={10} y1={11} x2={10} y2={17} />
                                <line x1={14} y1={11} x2={14} y2={17} />
                              </svg>
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <ul className="list-unstyled fs-sm border-bottom pb-4 mb-4">
                            <li className="d-flex align-items-center justify-content-between mb-1">
                              <span className="me-2">Subtotal:</span>
                              <span className="text-end">
                                ${cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}
                              </span>
                            </li>

                            <li className="d-flex align-items-center justify-content-between mb-1">
                              <span className="me-2">Tax:</span>
                              <span className="text-end">+ $ {Number(taxSummary.taxAmount || 0).toFixed(2)}</span>
                            </li>

                            <li className="d-flex align-items-center justify-content-between">
                              <span className="me-2">Shipping:</span>
                              <span className="text-end">+ $ {Number(shippingCharge || 0).toFixed(2)}</span>
                            </li>
                          </ul>

                          <div className="d-flex align-items-center justify-content-between">
                            <h5>Total</h5>
                            <h5>${Number(taxSummary.finalTotal || 0).toFixed(2)}</h5>
                          </div>

                          <hr className="mb-4" />
                          <div className="col-auto mb-3">
                            <div className="input-group">
                              <input
                                id="promoCode1"
                                type="text"
                                className="form-control"
                                onChange={(e) => setPromoCode(e.target.value)}
                                placeholder="Promo code"
                                value={promoCode}
                              />
                              <button className="btn btn-primary" onClick={handleApplyPromoCode} type="button" id="button-promo">
                                Apply
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <Link className="btn btn-primary btn-shadow d-block w-100" to="/">Shop Now</Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Checkout;
